export default __webpack_public_path__ + "static/img_welfare_9@2x-de6f36ce5daf4f0b46e64099abad3b59.jpg";